import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsUserLoggedIn } from 'redux/auth';
import AutoLogout from '../../components/AutoLogout';
import { PORTAL } from '../../utils/constants/variable';

const RequireAuth = () => {
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const location = useLocation();
  const { userFlow } = useSelector((state) => state.auth);

  return isUserLoggedIn ? (
    userFlow === PORTAL.CUSTOMER ? (
      <AutoLogout>
        <Outlet />
      </AutoLogout>
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/mymembership" state={{ from: location }} replace />
  );
};

export default RequireAuth;
